import React from "react";

export default function PaymentFailed() {
  return (
    <div style={{ maxWidth: 640, margin: "40px auto" }}>
      <h1>Payment failed</h1>
      <p>We couldn’t complete your payment. Please try another card or method.</p>
      <a href="/checkout" style={{ display: "inline-block", marginTop: 12 }}>Back to checkout</a>
    </div>
  );
}
